module.exports = "data:application/font-woff2;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI2OWY4YTA2MTdhYzQ3MmY3OGU0NTg0MTMyM2EzZGY5ZS53b2ZmMiI7"


//////////////////
// WEBPACK FOOTER
// ../~/materialize-css/fonts/roboto/Roboto-Light.woff2
// module id = 450
// module chunks = 0